/* eslint-disable max-len */
import Image1 from "assets/images/psp/illustration-search.svg";
import Image2 from "assets/images/illustration-compare-locations.svg";
import Image3 from "assets/images/illustration-reserve-date.svg";

import PublicStorage from "assets/images/logos/public-storage.svg";
import LifeStorage from "assets/images/logos/life-storage.svg";
import CubeSmart from "assets/images/logos/cube-smart.svg";
import StorageMart from "assets/images/logos/storage-mart.png";

const CLP_HEADER_DATA = {
	heading: "Find the Cheapest Storage Units Near You",
	description:
		"Search and compare more storage locations and units than any other storage site.",
	customDescription: {
		textBefore: "Over 97% of Reviewers Have Given Us a ",
		colorText: "4 out of 5 Star Rating or Higher",
		textAfter: " on Trustpilot!"
	}
};

const STEPS_CARDS_DATA = [
	{
		image: Image1,
		step: "Step 1",
		heading: "Search for Facilities",
		description:
			"Search by city or zip code to see available storage units in your area."
	},
	{
		image: Image2,
		step: "Step 2",
		heading: "Compare Storage Facilities",
		description:
			"Find the best storage facility for you based on location, size, amenities, and price."
	},
	{
		image: Image3,
		step: "Step 3",
		heading: "Reserve a Storage Unit",
		description:
			"Reserve online or by phone for FREE with no cancellation fees."
	}
];

const REVIEWS_CARDS_DATA = [
	{
		heading: "See What Storage.com Customers Are Saying",
		description:
			"Making your storage search and reservation experience easy and fast is our mission. Hear what our customers say about it!",
		customCard: true
	},
	{
		heading: "Storage.com is easy, quick, and responsive",
		description:
			"Needed a space for a visiting cousin to park a car trailer for a four day visit. I called storage.com and they immediately found a space with great pricing close to our house. The reservation took less than 5 minutes and I got a call from the storage unit manager within 10 minutes. I was very grateful and relieved to be able to make these arrangements so easily. Thanks!”",
		rating: {
			stars: 5,
			name: "George Ransom"
		}
	},
	{
		heading: "Excellent Customer Service!",
		description:
			"Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.”",
		rating: {
			stars: 5,
			name: "Ann Alarcon"
		}
	},
	{
		heading:
			"Very pleasant, helpful representative -- 5 stars depends on facility!",
		description:
			"Steve was very pleasant and helpful from the outset. I would have given him a 5 but the last star depends on the units and service on site and whether they provide a consistent experience. If they are like Steve, I am not worried.”",
		rating: {
			stars: 5,
			name: "S. Murphy"
		}
	}
];

const COMPANY_COUNT = {
	heading:
		"Choose From 20,000+ Local, Independent, and National Storage Facilities",
	description:
		"Reserve from Storage.com to get exclusive deals from the storage facilities in your area.",
	images: [PublicStorage, LifeStorage, CubeSmart, StorageMart]
};

export { CLP_HEADER_DATA, STEPS_CARDS_DATA, REVIEWS_CARDS_DATA, COMPANY_COUNT };
